import type { Layer, Widget } from "@deck.gl/core";
import { mapStore } from "src/js/stores/map/store";

// eslint-disable-next-line @typescript-eslint/ban-types
type DeckLoadingIndicatorAdapterWidgetProps = {};

/**
 * Used to set the loading state of deck.gl layers in valtio.
 */
export class DeckLoadingIndicatorAdapterWidget implements Widget<DeckLoadingIndicatorAdapterWidgetProps> {
  id: string;
  props = {};
  deckLoading: boolean;

  constructor(params: { deckLoading: boolean }) {
    this.deckLoading = params.deckLoading;
    this.id = `deckgl-loading-indicator-widget-${Date.now()}`;
  }

  setProps() {
    // noop - Required by Widget interface
  }

  onAdd() {
    // noop - Required by Widget interface
    return null;
  }

  onRemove() {
    this.deckLoading = false;
    mapStore.deckLoading = false;
  }

  onRedraw({ layers }: { layers: Layer[] }) {
    const isLoading = layers.some((layer) => !layer.isLoaded && layer.root.props.visible);
    if (this.deckLoading !== isLoading) {
      mapStore.deckLoading = isLoading;
      this.deckLoading = isLoading;
    }
  }
}
